import { render, staticRenderFns } from "./merge-history.vue?vue&type=template&id=5ae51884&scoped=true"
import script from "./merge-history.vue?vue&type=script&lang=js"
export * from "./merge-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae51884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae51884')) {
      api.createRecord('5ae51884', component.options)
    } else {
      api.reload('5ae51884', component.options)
    }
    module.hot.accept("./merge-history.vue?vue&type=template&id=5ae51884&scoped=true", function () {
      api.rerender('5ae51884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/merge-history/merge-history.vue"
export default component.exports